import Portal from '@mui/material/Portal';
import { PropsWithChildren } from 'react';

import { useDrawer } from './useDrawer';

export default function DrawerContent(props: PropsWithChildren) {
  const { children } = props;
  const drawer = useDrawer();

  return drawer.contentRef?.current && <Portal container={drawer.contentRef.current}>{children}</Portal>;
}
